

















































import {Component} from "vue-property-decorator";
import CommonBase from "../../CommonBase";
import rd from "@/modules/vRoutedefs";

@Component
export default class Reactivation extends CommonBase {
  readonly networkSetupTo = rd.docs.terminal.networksetup.path;
}
